'use server'

import { apiRequest, ApiResponse } from '../request'

export interface PinnedModulesResponse {
    moduleKeys: string[]
}

export async function getPinnedModules(): Promise<
    ApiResponse<PinnedModulesResponse>
> {
    return apiRequest('utils/settings/user/pinned-modules', {})
}

export async function updatePinnedModules(
    moduleKeys: string[]
): Promise<ApiResponse<PinnedModulesResponse>> {
    return apiRequest(
        'utils/settings/user/pinned-modules',
        { data: { moduleKeys } },
        'patch'
    )
}
